// constants/LatestInterviewSessionConstants.ts
export const LATEST_INTERVIEW_SESSION_REQUEST = 'LATEST_INTERVIEW_SESSION_REQUEST';
export const LATEST_INTERVIEW_SESSION_SUCCESS = 'LATEST_INTERVIEW_SESSION_SUCCESS';
export const LATEST_INTERVIEW_SESSION_FAIL = 'LATEST_INTERVIEW_SESSION_FAIL';
export const LATEST_INTERVIEW_SESSION_RESET = 'LATEST_INTERVIEW_SESSION_RESET';

// constants/InterviewSessionListConstants.ts
export const INTERVIEW_SESSION_LIST_REQUEST = 'INTERVIEW_SESSION_LIST_REQUEST';
export const INTERVIEW_SESSION_LIST_SUCCESS = 'INTERVIEW_SESSION_LIST_SUCCESS';
export const INTERVIEW_SESSION_LIST_FAIL = 'INTERVIEW_SESSION_LIST_FAIL';
export const INTERVIEW_SESSION_LIST_RESET = 'INTERVIEW_SESSION_LIST_RESET';

// constants/JobCreateConstants.ts
export const JOB_CREATE_REQUEST = 'JOB_CREATE_REQUEST';
export const JOB_CREATE_SUCCESS = 'JOB_CREATE_SUCCESS';
export const JOB_CREATE_FAIL = 'JOB_CREATE_FAIL';
export const JOB_CREATE_RESET = 'JOB_CREATE_RESET';






// constants/JobUpdateConstants.ts
export const JOB_UPDATE_REQUEST = 'JOB_UPDATE_REQUEST';
export const JOB_UPDATE_SUCCESS = 'JOB_UPDATE_SUCCESS';
export const JOB_UPDATE_FAIL = 'JOB_UPDATE_FAIL';
export const JOB_UPDATE_RESET = 'JOB_UPDATE_RESET';

// constants/JobDeleteConstants.ts
export const JOB_DELETE_REQUEST = 'JOB_DELETE_REQUEST';
export const JOB_DELETE_SUCCESS = 'JOB_DELETE_SUCCESS';
export const JOB_DELETE_FAIL = 'JOB_DELETE_FAIL';
export const JOB_DELETE_RESET = 'JOB_DELETE_RESET';

// constants/JobDetailConstants.ts
export const JOB_DETAIL_REQUEST = 'JOB_DETAIL_REQUEST';
export const JOB_DETAIL_SUCCESS = 'JOB_DETAIL_SUCCESS';
export const JOB_DETAIL_FAIL = 'JOB_DETAIL_FAIL';
export const JOB_DETAIL_RESET = 'JOB_DETAIL_RESET';

// constants/JobListConstants.ts
export const JOB_LIST_REQUEST = 'JOB_LIST_REQUEST';
export const JOB_LIST_SUCCESS = 'JOB_LIST_SUCCESS';
export const JOB_LIST_FAIL = 'JOB_LIST_FAIL';
export const JOB_LIST_RESET = 'JOB_LIST_RESET';

// constants/PreparationMaterialListConstants.ts
export const PREPARATION_MATERIAL_LIST_REQUEST = 'PREPARATION_MATERIAL_LIST_REQUEST';
export const PREPARATION_MATERIAL_LIST_SUCCESS = 'PREPARATION_MATERIAL_LIST_SUCCESS';
export const PREPARATION_MATERIAL_LIST_FAIL = 'PREPARATION_MATERIAL_LIST_FAIL';
export const PREPARATION_MATERIAL_LIST_RESET = 'PREPARATION_MATERIAL_LIST_RESET';

// constants/InterviewCreateConstants.ts
export const INTERVIEW_CREATE_REQUEST = 'INTERVIEW_CREATE_REQUEST';
export const INTERVIEW_CREATE_SUCCESS = 'INTERVIEW_CREATE_SUCCESS';
export const INTERVIEW_CREATE_FAIL = 'INTERVIEW_CREATE_FAIL';
export const INTERVIEW_CREATE_RESET = 'INTERVIEW_CREATE_RESET';

// constants/InterviewDetailConstants.ts
export const INTERVIEW_DETAIL_REQUEST = 'INTERVIEW_DETAIL_REQUEST';
export const INTERVIEW_DETAIL_SUCCESS = 'INTERVIEW_DETAIL_SUCCESS';
export const INTERVIEW_DETAIL_FAIL = 'INTERVIEW_DETAIL_FAIL';
export const INTERVIEW_DETAIL_RESET = 'INTERVIEW_DETAIL_RESET';




// constants/InterviewUpdateConstants.ts
export const INTERVIEW_UPDATE_REQUEST = 'INTERVIEW_UPDATE_REQUEST';
export const INTERVIEW_UPDATE_SUCCESS = 'INTERVIEW_UPDATE_SUCCESS';
export const INTERVIEW_UPDATE_FAIL = 'INTERVIEW_UPDATE_FAIL';
export const INTERVIEW_UPDATE_RESET = 'INTERVIEW_UPDATE_RESET';

// constants/InterviewDeleteConstants.ts
export const INTERVIEW_DELETE_REQUEST = 'INTERVIEW_DELETE_REQUEST';
export const INTERVIEW_DELETE_SUCCESS = 'INTERVIEW_DELETE_SUCCESS';
export const INTERVIEW_DELETE_FAIL = 'INTERVIEW_DELETE_FAIL';
export const INTERVIEW_DELETE_RESET = 'INTERVIEW_DELETE_RESET';

// constants/UserInterviewListConstants.ts
export const USER_INTERVIEW_LIST_REQUEST = 'USER_INTERVIEW_LIST_REQUEST';
export const USER_INTERVIEW_LIST_SUCCESS = 'USER_INTERVIEW_LIST_SUCCESS';
export const USER_INTERVIEW_LIST_FAIL = 'USER_INTERVIEW_LIST_FAIL';
export const USER_INTERVIEW_LIST_RESET = 'USER_INTERVIEW_LIST_RESET';

// constants/PreparationMaterialDetailConstants.ts
export const PREPARATION_MATERIAL_DETAIL_REQUEST = 'PREPARATION_MATERIAL_DETAIL_REQUEST';
export const PREPARATION_MATERIAL_DETAIL_SUCCESS = 'PREPARATION_MATERIAL_DETAIL_SUCCESS';
export const PREPARATION_MATERIAL_DETAIL_FAIL = 'PREPARATION_MATERIAL_DETAIL_FAIL';
export const PREPARATION_MATERIAL_DETAIL_RESET = 'PREPARATION_MATERIAL_DETAIL_RESET';





export const PREPARATION_MATERIAL_CREATE_REQUEST = 'PREPARATION_MATERIAL_CREATE_REQUEST';
export const PREPARATION_MATERIAL_CREATE_SUCCESS = 'PREPARATION_MATERIAL_CREATE_SUCCESS';
export const PREPARATION_MATERIAL_CREATE_FAIL = 'PREPARATION_MATERIAL_CREATE_FAIL';
export const PREPARATION_MATERIAL_CREATE_RESET = 'PREPARATION_MATERIAL_CREATE_RESET';




export const PREPARATION_MATERIAL_DELETE_REQUEST = 'PREPARATION_MATERIAL_DELETE_REQUEST';
export const PREPARATION_MATERIAL_DELETE_SUCCESS = 'PREPARATION_MATERIAL_DELETE_SUCCESS';
export const PREPARATION_MATERIAL_DELETE_FAIL = 'PREPARATION_MATERIAL_DELETE_FAIL';
export const PREPARATION_MATERIAL_DELETE_RESET = 'PREPARATION_MATERIAL_DELETE_RESET';




export const PREPARATION_BLOCK_UPDATE_REQUEST = 'PREPARATION_BLOCK_UPDATE_REQUEST';
export const PREPARATION_BLOCK_UPDATE_SUCCESS = 'PREPARATION_BLOCK_UPDATE_SUCCESS';
export const PREPARATION_BLOCK_UPDATE_FAIL = 'PREPARATION_BLOCK_UPDATE_FAIL';
export const PREPARATION_BLOCK_UPDATE_RESET = 'PREPARATION_BLOCK_UPDATE_RESET';




export const CODING_QUESTION_UPDATE_REQUEST = 'CODING_QUESTION_UPDATE_REQUEST';
export const CODING_QUESTION_UPDATE_SUCCESS = 'CODING_QUESTION_UPDATE_SUCCESS';
export const CODING_QUESTION_UPDATE_FAIL = 'CODING_QUESTION_UPDATE_FAIL';
export const CODING_QUESTION_UPDATE_RESET = 'CODING_QUESTION_UPDATE_RESET';




export const PREPARATION_MATERIAL_MARKING_REQUEST = 'PREPARATION_MATERIAL_MARKING_REQUEST';
export const PREPARATION_MATERIAL_MARKING_SUCCESS = 'PREPARATION_MATERIAL_MARKING_SUCCESS';
export const PREPARATION_MATERIAL_MARKING_FAIL = 'PREPARATION_MATERIAL_MARKING_FAIL';
export const PREPARATION_MATERIAL_MARKING_RESET = 'PREPARATION_MATERIAL_MARKING_RESET';




// actionTypes.js

// InterviewRoomCreateView Constants
export const CREATE_INTERVIEW_ROOM_REQUEST = 'CREATE_INTERVIEW_ROOM_REQUEST';
export const CREATE_INTERVIEW_ROOM_SUCCESS = 'CREATE_INTERVIEW_ROOM_SUCCESS';
export const CREATE_INTERVIEW_ROOM_FAILURE = 'CREATE_INTERVIEW_ROOM_FAILURE';
export const CREATE_INTERVIEW_ROOM_RESET = 'CREATE_INTERVIEW_ROOM_RESET';

// InterviewRoomDetailView Constants
export const FETCH_INTERVIEW_ROOM_DETAILS_REQUEST = 'FETCH_INTERVIEW_ROOM_DETAILS_REQUEST';
export const FETCH_INTERVIEW_ROOM_DETAILS_SUCCESS = 'FETCH_INTERVIEW_ROOM_DETAILS_SUCCESS';
export const FETCH_INTERVIEW_ROOM_DETAILS_FAILURE = 'FETCH_INTERVIEW_ROOM_DETAILS_FAILURE';
export const FETCH_INTERVIEW_ROOM_DETAILS_RESET = 'FETCH_INTERVIEW_ROOM_DETAILS_RESET';
